import PhoneIcon from '@mui/icons-material/Phone';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { React, useState } from 'react';
import InputMask from 'react-input-mask';
import Tooltip from '@mui/material/Tooltip';
import Colors from '../colors';

const MaskedInput = styled(InputMask)(() => ({
    height: '50px',
    background: 'var(--light-gray)',
    borderRadius: '8px',
    border: 'none',
    width: '100%',
    fontFamily: 'Jost',
    fontWeight: '400',
    fontSize: '16px',
    paddingLeft: '5px',
    paddingRight: '5px',
    display: 'block',
    '&:focus': {
        outline: '2px solid gainsboro',
    },
}));

const LabelStyle = styled('label')(() => ({
    fontFamily: 'Jost',
    fontWeight: '600',
    color: 'var(--dark-gray)',
    textTransform: 'capitalize',
    display: 'block',
}));

function PhoneTextInput({ label, phoneNumberText, setPhoneNumberText,  disabled = false }) {
    const [showAlert, setAlert] = useState(false);
    
    function extractPhoneNumber(phoneNumber) {
        const cleanedNumber = phoneNumber.replace(/[()-]/g, '');
        const extractedNumber = cleanedNumber.replace(/\D/g, '');
        return extractedNumber;
    }
    const handlePhoneNumberChange = (e) => {
        const extractedNumber = extractPhoneNumber(e.target.value);
        if(extractedNumber === '911'){
        setPhoneNumberText(extractedNumber);
        }else{
            setPhoneNumberText(e.target.value)
        }
    };
      const isEmergencyNumber = extractPhoneNumber(phoneNumberText) === '911';
      const mask = isEmergencyNumber ? '999' : '(999) 999-9999';
    const handlePhoneClick = () => {
        const phoneNumberValue = (phoneNumberText || '').trim();
        if(extractPhoneNumber(phoneNumberValue) === '911'){
            setAlert(false);
            window.open(`tel:${phoneNumberText}`, '_self');
        }
        else if (phoneNumberValue) {
            setAlert(false);
            window.open(`tel:${phoneNumberText}`, '_self');
        } else {
            setAlert(true)
            setTimeout(() => {
                setAlert(false);
            }, 3000);
        }
    }

    return (
        <Box
            sx={{
                display: 'grid',
                alignItems: 'center',
                gridTemplateColumns: '1fr 40px',
                gridTemplateRows: 'auto auto',
                gap: '6px',
            }}
        >
            <Box>
                <LabelStyle>{label}</LabelStyle>
                <MaskedInput
                    mask={mask}
                    value={phoneNumberText}
                    onChange={handlePhoneNumberChange}
                    alwaysShowMask={true}
                    disabled = {disabled}
                    sx={{ width: '100%' }}
                />
            </Box>
            <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', paddingBottom: '9px' }}>
                <Tooltip title="Call"><PhoneIcon
                    sx={{ fontSize: 32, cursor: 'pointer', color: Colors.blue }}
                    onClick={handlePhoneClick}
                /></Tooltip>
            </Box>
            {showAlert && (
                <div
                    style={{
                        color: 'red',
                        fontSize: '16px',
                        marginBottom: '5px',
                        gridColumn: '1 / -1',
                        textAlign: 'center',
                    }}
                >
                    Please enter a valid Phone Number
                </div>
            )}
        </Box>
    );    
}

export default PhoneTextInput;